import {Grid} from "@mui/material";
import Typography from "@mui/material/Typography";
import '../Styles/Papers.css'
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import React from "react";

export default function SponsorsList() {
    return (
        <Grid container>
            <Grid item sm={0} md={2}>
            </Grid>
            <Grid item sm={12} md={8}>
                <Typography sx={{fontWeight: 'bold'}} gutterBottom variant="h5" component="div">
                    Sponsors
                </Typography>

                <Typography variant="body1">
                    <List sx={{ listStyleType: 'disc', pl: 2, lineHeight: 2}}>
                        <ListItem sx={{ p: 0,  display: 'list-item' }}>
                            Neue Bachgesellschaft (with funds from the Johann Sebastian Bach Foundation)
                        </ListItem>
                        <ListItem sx={{ p: 0,  display: 'list-item' }}>
                            City of Bad Säckingen
                        </ListItem>
                        <ListItem sx={{ p: 0,  display: 'list-item' }}>
                            Sparkasse Hochrhein
                        </ListItem>
                        <ListItem sx={{ p: 0,  display: 'list-item' }}>
                            Sparkassen-Kulturstiftung
                        </ListItem>
                        <ListItem sx={{ p: 0,  display: 'list-item' }}>
                            Historic Brass Society
                        </ListItem>
                        <ListItem sx={{ p: 0,  display: 'list-item' }}>
                            International Trumpet Guild
                        </ListItem>
                        <ListItem sx={{ p: 0,  display: 'list-item' }}>
                            Egger – Swiss Made Brass
                        </ListItem>
                        <ListItem sx={{ p: 0,  display: 'list-item' }}>
                            Maller Baroque Brass Instruments
                        </ListItem>
                        <ListItem sx={{ p: 0,  display: 'list-item' }}>
                            BFB Brass
                        </ListItem>
                        <ListItem sx={{ p: 0,  display: 'list-item' }}>
                            Martin Schmid Blechbläsernoten
                        </ListItem>
                        <ListItem sx={{ p: 0,  display: 'list-item' }}>
                            Neubauer Trumpets & Hornsan
                        </ListItem>
                        <ListItem sx={{ p: 0,  display: 'list-item' }}>
                            Vincent DiMartino
                        </ListItem>

                    </List>

                </Typography>

            </Grid>
            <Grid item sm={0} md={2}>
            </Grid>
        </Grid>
    )
}